import React, { useEffect, useState } from 'react';
import PageHeaderText from 'components/base/page-header-text';
import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { useNavigate, useParams } from 'react-router-dom';
import useDashboardContext from 'contexts/dashboard.context';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import KitchenRequestItem from 'components/kitchen-request-item';
import { RequestType } from 'models/item-request.model';

type editedItemsType = {
  kitchen_request_item_id: string;
  quantity_sent: number;
  batch_no: number;
  batch_id: string;
}[];

const ReviewItemRequestDetails = () => {
  const router = useNavigate();
  const { setIsBackLink, setBackLinkTitle } = useDashboardContext();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [onConfirmLoading, setOnConfirmLoading] = useState(false);
  const [requestItem, setRequestItem] = useState({} as RequestType);
  const [editedItems, setEditedItems] = useState([] as editedItemsType);

  useEffect(() => {
    setIsBackLink(true);
    setBackLinkTitle('Return to item requests');
    return () => {
      setIsBackLink(false);
      setBackLinkTitle('');
    };
  }, []);

  const handleUpdate = async () => {
    const data = {
      items: editedItems
    };
    try {
      setOnConfirmLoading(true);
      const res = await apiService.put(`kitchen-store/requests/${id}/send`, {
        version: 'v2',
        data
      });
      if (res) {
        toast(<ToastMessage type='success' message=' Update successful' />);
        router(-1);
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setOnConfirmLoading(false);
    }
  };
  const getRequestDetails = async () => {
    setLoading(true);
    try {
      const res: any = await apiService.get(`kitchen-store/requests/${id}`, { version: 'v2' });
      setRequestItem(res.data.data);
    } catch (e: any) {
      console.log(e, 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getRequestDetails();
  }, []);

  return (
    <div>
      <PageHeaderText
        title={`Review request #${requestItem?.code} `}
        description='Update the quantity supplied to the kitchen as necessary '
      />
      <div className='border-4 border-[#F7F7F8] rounded py-[24px]  md:max-w-[670px]'>
        <div className='flex justify-between px-[28px]'>
          <div className=' pb-5'>
            <p className='font-semibold text-[24px]'>Update sent items </p>
            <p className='text-[#6F7376] text-sm'>
              State the quantity sent to the kitchen from the request
            </p>
          </div>
        </div>
        {loading ? (
          <div className='flex justify-center items-center w-full h-full'>
            <p>Loading </p>
          </div>
        ) : !requestItem ? (
          <div className='flex justify-center items-center w-full h-full'>
            <p>Request Item not found </p>
          </div>
        ) : (
          requestItem?.items
            ?.sort((a, b) => a.quantity - b.quantity)
            ?.map((item) => (
              <KitchenRequestItem
                key={item.id}
                setItemRequestToEdit={(items, itemId) => {
                  const id = itemId || items[0]?.kitchen_request_item_id;
                  if (!id) return;
                  setEditedItems((prev: any) => [
                    ...prev.filter((p: any) => p.kitchen_request_item_id !== id),
                    ...items
                  ]);
                }}
                requestItem={item}
              />
            ))
        )}
        <div>
          <div className='flex gap-6 items-center justify-end mt-6 mx-[28px] ml-auto'>
            <Button variant='link' color='gray' small onClick={() => router(-1)}>
              Back
            </Button>
            <Button
              variant='block'
              color='primary'
              small
              className='w-[153px] h-[43px]'
              onClick={handleUpdate}
              loading={onConfirmLoading}
              disabled={onConfirmLoading}>
              Update
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewItemRequestDetails;
